/** Floor plan drawing app types */

export interface UserProfile {
  id: string;
  email: string;
  credits: number;
}

export interface FloorPlan {
  id: string;
  user_id: string;
  name: string;
  canvas_data: unknown;
  thumbnail_url: string | null;
  scale_unit: 'm' | 'ft';
  scale_value: number;
  created_at: string;
  updated_at: string;
}

export interface FloorPlanExport {
  id: string;
  floor_plan_id: string;
  user_id: string;
  format: 'png' | 'pdf' | 'svg';
  credits_used: number;
  created_at: string;
}

export type ToolId =
  | 'select'
  | 'room'
  | 'polygon'
  | 'wall'
  | 'dimension'
  | 'text'
  | 'symbol'
  | 'eraser';

export type SymbolId =
  | 'door'
  | 'door-room'
  | 'door-cupboard'
  | 'double-door'
  | 'sliding-door'
  | 'window'
  | 'window-sliding'
  | 'window-bay'
  | 'stairs'
  | 'stairs-l'
  | 'bed-double'
  | 'bed-single'
  | 'sofa'
  | 'sofa-two'
  | 'sofa-l'
  | 'sink'
  | 'sink-double'
  | 'kitchen-sink'
  | 'kitchen-sink-double'
  | 'range'
  | 'range-wide'
  | 'toilet'
  | 'toilet-wall'
  | 'bathtub'
  | 'bathtub-shower'
  | 'corner-shower'
  | 'stall-shower'
  | 'north'
  | 'north-arrow'
  | 'north-circle'
  | 'north-ns'
  | 'north-compass'
  | 'north-point';

/** Stair label and arrow. `dn` is the plan abbreviation for down. */
export type StairDirection = 'up' | 'dn';

export interface CanvasShape {
  id: string;
  type: 'room' | 'polygon' | 'wall' | 'dimension' | 'text' | 'symbol';
  x: number;
  y: number;
  width?: number;
  height?: number;
  rotation?: number;
  label?: string;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  thickness?: number;
  opacity?: number;
  points?: number[];
  symbolId?: SymbolId;
  /** Stairs only. Omitted plans keep the original up arrow. */
  stairDirection?: StairDirection;
  /** Mirror the symbol left-to-right (hinge side, fixture facing). */
  flipX?: boolean;
  /** Mirror the symbol top-to-bottom (door swing into the other room). */
  flipY?: boolean;
}

export type ExportFormat = 'png' | 'pdf' | 'svg';

export const EXPORT_CREDITS: Record<ExportFormat, number> = {
  png: 2,
  pdf: 3,
  svg: 4,
};
